module.exports = __webpack_public_path__ + "img/she_killed_in_ecstasy_mobile.73c70a3a.jpg";